<template>
    <!-- <NuxtLink :to="localePath(`/texty/${knihaKod}/${temaKod}`)">
        <span class="uapz05" v-html="formattedHtml" />
    </NuxtLink> -->
    <span v-if="html.includes('(')">(</span
    ><template
        v-for="(code, i) in parts"
        :key="i"
        >{{ i === 0 ? "" : " / "
        }}<NuxtLink
            v-tooltip.bottom="footnoteContent(code)"
            :to="localePath(`/vyhledavani?text=${code}`)"
            class="uapz05 cursor-pointer"
        >
            {{ code }}
        </NuxtLink></template
    ><span v-if="html.includes(')')">)</span>
</template>

<script lang="ts" setup>
const localePath = useLocalePath()
const store = useMainStore()

const props = defineProps<{
    html: string
}>()

const formattedHtml = props.html.replace(
    /<span class="uapz05">\s?\(?(.*?)\)? ?<\/span>/g,
    "$1"
)

const parts = ref<string[]>([])
const codes = formattedHtml?.split(/ ?(\/|,) ?/g)
codes?.forEach(code => {
    if (code === "/" || code === ",") return
    parts.value.push(code)
})

const footnoteContent = (code: string) => {
    const footnoteContent = store.tooltips.limity.find(
        limit =>
            // limit.KOD === formattedHtml.match(/L.\d{1,2}/)?.[0]?.replace(".", "")
            limit.KOD === code
    )?.NAZEV
    if (footnoteContent) return footnoteContent
}
</script>

<style scoped></style>
